const Config = {
  client: "http://localhost:3000",
  // server: "http://localhost:4000"
  server: "https://api.europeennes.bloomassociation.org"
};

export default Config;
